import React from 'react';
import { Tooltip } from 'antd';
import './MorningstarStylebox.css';  // Ensure to create this CSS file to handle the styling

const containerStyle = (showLabels, size) => ({
  display: 'grid',
  gridTemplateColumns: showLabels ? `20px repeat(3, ${size}px)` : `repeat(3, ${size}px)`,
  gridTemplateRows: showLabels ? `20px repeat(3, ${size}px)` : `repeat(3, ${size}px)`,
  gap: '1px',
  alignItems: 'center',
  justifyContent: 'center',
});

const cellStyle = (size, opacity) => ({

  width: `${size}px`,
  height: `${size}px`,
  backgroundColor: `rgba(0, 128, 0, ${opacity})`,  // Green with variable opacity
  border: `${opacity===0?'1px solid #ddd': 'rgba(0, 128, 0)'}`,  // Light grey border
});

const labelStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: 'bold',
};

const MorningstarStylebox = ({ styles, size = 10, showLabels = false }) => {
  const defaultGrid = Array(9).fill(0);

  if (styles && styles[0] && typeof styles[0] === 'object') {
    styles.forEach(style => {
      const [key, value] = Object.entries(style)[0];
      const index = styleOrder.indexOf(key);
      if (index !== -1) {
        defaultGrid[index] = value;
      }
    });
  } else if (styles) {
    styles.forEach(style => {
      const index = styleOrder.indexOf(style);
      if (index !== -1) {
        defaultGrid[index] = 1;
      }
    });
  }

  const rows = ['L', 'M', 'S'];
  const cols = ['V', 'B', 'G'];

  return (
    <div style={containerStyle(showLabels, size)}>
      {showLabels && <div />} {/* Placeholder for top-left corner */}
      {showLabels && cols.map(col => <div key={col} style={{...labelStyle, fontSize: `${size}px`}}>{col}</div>)}
      {rows.map((row, rowIndex) => (
        <>
          {showLabels && <div key={row} style={{...labelStyle, fontSize: `${size}px`}}>{row}</div>}
          {defaultGrid.slice(rowIndex * 3, rowIndex * 3 + 3).map((opacity, colIndex) => (
            <Tooltip title={styleOrder[rowIndex * 3 + colIndex].replace('_', ' ').toUpperCase()} key={colIndex}>
              <div style={cellStyle(size, opacity)} />
            </Tooltip>
          ))}

        </>
      ))}
    </div>
  );
};

const styleOrder = [
  'large_value', 'large_blend', 'large_growth',
  'mid_value', 'mid_blend', 'mid_growth',
  'small_value', 'small_blend', 'small_growth'
];

export default MorningstarStylebox;
